// =============================================================================
// MAIN JS ENTRY POINT — Astrilax
// Imports per-section modules (Vite handles tree-shaking & bundling).
// =============================================================================

import './header.js';
import './accordion.js';

// =============================================================================
// FOOTER YEAR
// =============================================================================

const yearEl = document.getElementById('footer-year');
if (yearEl) yearEl.textContent = new Date().getFullYear();

